import { useView } from "../../../hooks/useView";
import { VizContainerProps } from "./VizContainer";
import "../Viz.scss";
import { ConfidenceBadge } from "./Shared/ConfidenceBadge";

export type VizDetailsProps = VizContainerProps;

export function VizDetails(props: VizDetailsProps) {
    const { view } = useView(props.viewId);
    const selectedEntity = view?.selectedEntity;

    const isBasicProperty = ([key, _]) =>
        selectedEntity.dataDescription.properties[key] &&
        selectedEntity.dataDescription.properties[key].userRelevance == "basic";

    return (
        <div className="viz-details viz-panel">
            <h2>Details</h2>
            {Object.entries(selectedEntity?.properties ?? {})
                .filter(isBasicProperty)
                .map(([key, value]) => ({
                    displayName: selectedEntity.dataDescription.properties[key].displayName,
                    value: value,
                    displayValue: value?.display?.() ?? "",
                }))
                .filter(({ displayValue }) => displayValue != undefined && displayValue.length > 0)
                .map(({ displayName, value, displayValue }, i) => (
                    <div className="property" key={i}>
                        <div>{displayName}</div>
                        <div className="text-muted">
                            {displayValue}{" "}
                            {value.hasConfidence() && <ConfidenceBadge confidence={value.getConfidence()} />}
                        </div>
                    </div>
                ))}
        </div>
    );
}
